import React, { Fragment } from 'react';
export var LinkCreateContent = function LinkCreateContent(_ref) {
  var plugins = _ref.plugins,
    entityKey = _ref.entityKey;
  var chosenOne = plugins.find(function (plugin) {
    return plugin.key === entityKey;
  });
  if (!chosenOne) {
    throw new Error('Make sure you specified a valid entityKey');
  }
  return /*#__PURE__*/React.createElement(Fragment, null, chosenOne.form);
};